import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import searchIcon from '../../assets/search.svg'
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded, Public, Search } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import Statbox from "../Dashborad/Statbox";
import CustomTabBar from "../Utils/CustomTabBar";
import { CircleLoader } from "react-spinners";

const JobsListScreen = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const date = new Date(isostring); // works for ISO string & ObjectId date

    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [hasEnded, setHasEnded] = useState(false)
    const [searchedJobs, setSearchedJobs] = useState([])
    const [searchQuery, setSearchQuery] = useState("")
    const [metricData, setMetricData] = useState({})
    const [loading, setLoading] = useState(false)

    const FetchJobs = async (page, type) => {

        if (page == 1) {
            setHasEnded(false)
            setJobs([])
        }
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/jobs/get-jobs?page=${page}&limit=${30}&type=${type}${page == 1 ? `&d_data=true` : ""}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setJobs(prev => page == 1 ? data.response : [...prev, ...data.response]);
            setCurrentPage(page)
            if (data.response.length < 30) {
                setHasEnded(true)
            }

            if (page == 1) {
                setMetricData(data.d_data ?? {})
            }
            setLoading(false);
        } else {
            setLoading(false)
        }

    };

    const SearchJobs = async (q) => {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/jobs/search?q=${q}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSearchedJobs(data.data);
        }
        setLoading(false)
    };

    useEffect(() => {
        FetchJobs(1, "0");
    }, []);

    useEffect(() => {
        if (searchQuery.length > 0) {
            const delayDebounceFn = setTimeout(() => {
                SearchJobs(searchQuery);
            }, 500); // 500ms delay

            return () => clearTimeout(delayDebounceFn);
        } else {
            setSearchedJobs([]); // Clear results when input is empty
        }
    }, [searchQuery]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [jobs, setJobs] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>

                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                >
                    <Header
                        title={`Jobs & Internships`}
                        subtitle={"Discover ongoing job and internships."}
                    />
                </Box>

                <Box
                    display={"grid"}
                    gridTemplateColumns="repeat(12,1fr)"
                    gridAutoRows={"100px"}
                    pb={"20px"}
                    gap={(isMobileScreen || isTabScreen) ? "20px" : "20px"}
                >
                    {/* ROW 1 */}
                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        sx={{
                            borderRadius: "20px",
                            border: "1.7px solid transparent",
                            background:
                                "linear-gradient(#ffffff00 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, rgba(214, 152, 36, 1)) border-box",

                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center">
                        <Statbox
                            title={metricData.totalJobs ?? 0}
                            subtitle="Total Jobs"
                            users={true}
                            report={0}
                        />
                    </Box>

                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.internships ?? 0}
                            subtitle="Active Internships"
                            loading={false}
                            users={true}
                            report={0}
                        />
                    </Box>
                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.jobs ?? 0}
                            subtitle="Active Jobs"
                            loading={false}
                            users={true}
                            report={0}
                        />
                    </Box>
                    <Box
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        backgroundColor={colors.primary[400]}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            // todayonboardusers
                            title={metricData.closed ?? 0}
                            subtitle="Expired or Closed"
                            onClick={() => {

                            }}
                            users={true}
                        />
                    </Box>

                    {/* ROW 2 */}




                </Box>


                <Box sx={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: "center",
                    marginBottom: "20px",
                }}>
                    <Box sx={{
                        flexDirection: 'row',
                        display: 'flex',
                        borderRadius: "15px",
                        border: "1px solid #aaaaaa10",
                        background: "#ffffff08",
                        maxWidth: isMobileScreen ? "100%" : isTabScreen ? "80%" : "32.5%",
                        minWidth: isMobileScreen ? "100%" : "500px"
                    }}>

                        <img
                            alt="search_icon"
                            width="20px"
                            height="20px"
                            style={{
                                objectFit: 'contain',
                                filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                                alignSelf: 'center',
                                marginLeft: "15px"
                            }}
                            src={searchIcon}
                        />
                        <input
                            placeholder="Search a job by name..."
                            enterKeyHint={'search'}
                            value={searchQuery}
                            // onKeyDown={(e) => {
                            //     if (e.key === "search" || e.key === "enter") {
                            //         searchJob(e.target.value)
                            //         e.target.value = "";
                            //     }
                            // }}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                outline: 'none',
                                backgroundColor: "transparent",
                                borderWidth: 0,
                                padding: "15px 15px",
                                flex: 1,
                                fontSize: "14px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }}
                        />


                    </Box>


                </Box>



                <CustomTabBar
                    selectedTab={selectedTab}
                    tabs={["All Jobs", "Active Jobs", "Internships", "Freshers", "Priority Pass", "Boosted"]}
                    marginBottom="10px"
                    gap={isMobileScreen ? "12px" : "15px"}
                    fontSize={isMobileScreen ? "15px" : "18px"}
                    nonSelectedFontSize={isMobileScreen ? "12px" : "13px"}
                    marginLeft="5px"
                    onChange={(index) => {
                        setSelectedTab(index)
                        FetchJobs(1, `${index}`)
                    }}/>



                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>

                    <Box
                        display={"flex"}
                        gap="20px"
                        sx={{
                            flexWrap: 'wrap',
                            flexDirection: 'row'
                        }}
                        pb={"20px"}
                    >
                        {
                            (searchQuery.length > 0 ? searchedJobs : jobs).map((dt) => {
                                return (
                                    <Box
                                        // key={`${transaction.txId}-${i}`}

                                        display="flex"
                                        component={Link}
                                        borderRadius={"10px"}
                                        to={{
                                            pathname: "/admin/job-details",
                                            search: `?job=${dt._id}`,
                                            state: { fromDashboard: true },
                                            // console.log(first)
                                        }}

                                        sx={{
                                            textDecoration: 'none', flexDirection: 'column',
                                            display: 'flex', width: isMobileScreen ? "100%" :  "30%", background: "#ffffff08",
                                            padding: "15px"
                                        }}
                                    >

                                        <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "10px" }}>
                                            <Box sx={{
                                                display: 'flex', alignItems: 'center',
                                                width: "45px", height: "45px",
                                                position: "relative", flexDirection: "column"
                                            }}>
                                                <img
                                                    alt="img"
                                                    width={"100%"}
                                                    height={"100%"}
                                                    src={`${dt.club ? dt.club?.clubLogo ?? "" : dt.creator?.image[0] ?? ""}`}
                                                    style={{
                                                        background: "#ffffff10",
                                                        textDecoration:"none",
                                                        color: "#ffffff",
                                                        aspectRatio: 1 / 1,
                                                        cursor: "pointer", objectFit: 'cover',
                                                        borderRadius: "10px",
                                                        border: `2px solid ${(dt.priorityPass?.enabled && new Date(dt.priorityPass?.validity).getTime() > new Date().getTime() )? "#ff8800" : (dt.boost?.isBoosted && new Date(dt.boost?.validity).getTime() > new Date().getTime() ) ? "#943bff" : "#ffffff10"}`
                                                    }}
                                                />

                                                <Box sx={{ width: "100%", height: "100%", position: "absolute", background: "#00000010" }} />


                                                {/* <Box sx={{
                                                display: "flex", flexDirection: "column", background: "#0f0f0f", position: "absolute",
                                                margin: "10px", borderRadius: "11px",
                                                paddingInline: "10px", paddingBlock: "5px", alignSelf: "flex-end", alignItems: "center",
                                                border: "1px solid #aaaaaa20"
                                            }}>


                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                    }}
                                                    fontSize={"11.5px"}>{Convert_Time_Zone(community.startDate)}</Typography>

                                            </Box> */}
                                            </Box>

                                            <Box sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                flex: 1

                                            }}>
                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    fontSize={"14px"}
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 1,      // change to 3,4 if needed
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden"
                                                    }}
                                                >{dt.title}</Typography>

                                                <Typography color={"#aaaaaa"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        marginTop: "2px",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 1,      // change to 3,4 if needed
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden"
                                                    }}
                                                    fontSize={"11px"}>{Convert_Time_Zone(dt.createdAt)} | By {dt.club ? dt?.club?.title : dt?.creator?.full_name ?? ""}</Typography>
                                            </Box>

                                            {
                                                (!dt.isActive || new Date(dt.validTill).getTime() < Date.now()) && (
                                                    <Typography color={"#ff8800"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            marginTop: "5px",
                                                            display: "-webkit-box",
                                                            border: "1.5px solid #ff880010",
                                                            background: "#ff880010",
                                                            paddingInline: "8px",
                                                            borderRadius: "4px",
                                                            paddingBlock: "2px",
                                                            alignSelf: "flex-start",
                                                            WebkitLineClamp: 1,      // change to 3,4 if needed
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden"
                                                        }}
                                                        fontSize={"11px"}>Closed</Typography>
                                                )
                                            }


                                        </Box>

                                        <Box sx={{
                                            height: "1px", alignSelf: "stretch", background: "#aaaaaa10",
                                            marginTop: "10px"
                                        }} />
                                        <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: "5px" }}>



                                            <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "5px" }} >

                                                {
                                                    [dt.workType, dt.experience, dt.employmentType].map((item, index) => (
                                                        <Typography color={"#ffffff90"}
                                                            fontFamily={"poppins-reg"}
                                                            style={{
                                                                marginTop: "5px",
                                                                display: "-webkit-box",
                                                                background: "#ffffff10",
                                                                paddingInline: "10px",
                                                                borderRadius: "4px",
                                                                paddingBlock: "4px",
                                                                alignSelf: "flex-start",
                                                                WebkitLineClamp: 1,      // change to 3,4 if needed
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden"
                                                            }}
                                                            fontSize={"12px"}>{item}</Typography>
                                                    ))
                                                }

                                            </Box>

                                        </Box>

                                    </Box>
                                );
                            })}
                    </Box>


                    {
                        hasEnded && !loading && (
                            <Box sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "12px", color: "#ffffff90"
                            }} >- Looks like you have reached to the end -</Box>
                        )
                    }

                    {
                        !hasEnded && !loading && (
                            <Box onClick={() => {
                                if (!hasEnded) {
                                    FetchJobs(currentPage + 1, `${selectedTab}`)
                                }
                            }} sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "13px", borderRadius: "10px", border: "1px solid #943bff",
                                background: "#943bff20", cursor: "pointer",
                            }} >Load More</Box>
                        )
                    }

                </Box>

            </Box>
        </>
    );
}

export default JobsListScreen;
